/**
 * https://docs.stripe.com/terminal/references/api/js-sdk#api-methods
 */

export interface StripeError {
  code: string;
  message: string;
}
export const stripeUtil = {
  /**
   * https://docs.stripe.com/terminal/references/api/js-sdk#get-connection-status
   * @returns boolean
   */
  checkConnectStatus: () => {
    let status = false;
    if (!(window as any).terminal) return status;
    const statusStr = (window as any).terminal.getConnectionStatus();
    console.log('[stripe terminal]connect status::', statusStr);
    status = statusStr === 'connected';
    return status;
  },
  // https://docs.stripe.com/terminal/references/api/js-sdk#cancel-collect-payment-method
  cancelCollectPaymentMethod: () => {
    if (!(window as any).terminal) return false;
    return (window as any).terminal.cancelCollectPaymentMethod();
  },
  //https://docs.stripe.com/terminal/references/api/js-sdk#cancel-collect-setup-intent-payment-method
  cancelCollectSetupIntentPaymentMethod: () => {
    if (!(window as any).terminal) return false;
    return (window as any).terminal.cancelCollectSetupIntentPaymentMethod();
  },
};
